import { render, staticRenderFns } from "./ContentField.vue?vue&type=template&id=631c20e5"
import script from "./ContentField.vue?vue&type=script&lang=js"
export * from "./ContentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports